export default "__VITE_ASSET__DiO1t7Rb__"